import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CONSTANT_CURRENCY } from "../../../constant/common";
import {
  useElements,
  useStripe,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";
import { AuthContext } from "../../../context/AuthContext";
import { toast } from "react-toastify";
import api from "../../../api/api";

const getCardOptions = () => {
  const isMobile = window.innerWidth < 640;

  return {
    style: {
      base: {
        fontSize: "1.25rem",
        height: isMobile ? "48px" : "56px",
        lineHeight: isMobile ? "48px" : "56px",
        display: "flex",
        alignItems: "center",
        "::placeholder": {
          color: "#aab7c4",
        },
      },
      invalid: {
        color: "red",
      },
    },
  };
};

const PaymentModal = ({
  isPaymentModal,
  setIsPaymentModal,
  planDetails,
  setPlanDetails,
  handlePracticesSubmit
}) => {
  const { user, setUser } = useContext(AuthContext);

  const stripe = useStripe();
  const elements = useElements();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    fk_users_id: user?.users_id,
    fk_pricing_plan_id: planDetails?.pricing_plan_id,
    card_holder_name: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const [cardComplete, setCardComplete] = useState(false);
  const [expiryComplete, setExpiryComplete] = useState(false);
  const [cvcComplete, setCvcComplete] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) return;

    const { card_holder_name } = formData;

    let payload = {};
    if (!card_holder_name.trim()) {
      toast.error("Please enter card holder name");
      return;
    }

    if (!cardComplete || !expiryComplete || !cvcComplete) {
      toast.error("Please complete all card fields");
      return;
    }

    setIsSubmitting(true);
    const cardElement = elements.getElement(CardNumberElement);

    const { paymentMethod, error } = await stripe.createPaymentMethod({
      type: "card",
      card: cardElement,
      billing_details: {
        name: formData.card_holder_name,
      },
    });

    if (error) {
      console.error(error);

      toast.error(error.message || "Failed payment");

      setIsSubmitting(false);
      return;
    }

    payload = {
      stripe_response: JSON.stringify(paymentMethod),
      pricing_plan_id: planDetails?.pricing_plan_id,
    };
    try {
      setIsSubmitting(true);

      const response = await api.post("add-orders", payload, {
        headers: { "Content-Type": "application/json" },
      });

      setIsSubmitting(false);

      if (response?.data?.status === true) {
        toast.success(response.data?.message);

        setUser(response.data?.data?.user);

        setIsPaymentModal(false);
        
      } else {
        setIsSubmitting(false);
        console.log(response);

        toast.error(response?.data?.message || "Failed payment");
        return null;
      }
    } catch (error) {
      setIsSubmitting(false);

      console.error("Error :", error?.response?.data?.message);
      const errorMsg = error?.response?.data?.message
        ? error?.response?.data?.message
        : "Something went wrong. Please try again.";
      toast.error(errorMsg);
      return null;
    }
  };

  return (
    <>
      <div
        id="paymentModal"
        class={`fixed z-[999] inset-0 items-center justify-center bg-black bg-opacity-50 px-3 ${
          isPaymentModal === true ? "flex" : "hidden"
        }`}
      >
        <div className="mx-auto emailbox bg-white p-9 rounded-lg shadow-lg w-full max-w-lg relative min-h-[60vh] max-h-[90vh]">
          <button
            onClick={() => {
              setIsPaymentModal(false);
              setPlanDetails(null);
            }}
            type="button"
            className="absolute right-4 top-4"
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.41791 0.436139C0.685579 0.168311 1.04857 0.0178675 1.42704 0.0178675C1.80551 0.0178675 2.1685 0.168311 2.43617 0.436139L9.99103 7.99754L17.5459 0.436139C17.6777 0.299682 17.8351 0.190853 18.0092 0.115982C18.1834 0.0411107 18.3708 0.00171073 18.5602 5.3593e-05C18.7497 -0.00158926 18.9377 0.0345535 19.1131 0.106382C19.2886 0.17821 19.4479 0.284296 19.5819 0.418424C19.7159 0.552553 19.822 0.712052 19.8938 0.887623C19.9654 1.06319 20.0015 1.25131 19.9999 1.44099C19.9982 1.63068 19.9588 1.81814 19.884 1.99242C19.8093 2.16671 19.7005 2.32435 19.5642 2.45612L12.0093 10.0175L19.5642 17.5789C19.8242 17.8484 19.9681 18.2092 19.9648 18.5838C19.9616 18.9584 19.8115 19.3167 19.5468 19.5815C19.2821 19.8464 18.9242 19.9967 18.5499 19.9999C18.1757 20.0032 17.8151 19.8592 17.5459 19.5989L9.99103 12.0375L2.43617 19.5989C2.16697 19.8592 1.80643 20.0032 1.43218 19.9999C1.05793 19.9967 0.699938 19.8464 0.435296 19.5815C0.170653 19.3167 0.0205397 18.9584 0.0172997 18.5838C0.0140454 18.2092 0.157906 17.8484 0.41791 17.5789L7.97277 10.0175L0.41791 2.45612C0.150327 2.18824 0 1.82494 0 1.44612C0 1.06732 0.150327 0.704024 0.41791 0.436139Z"
                fill="black"
              ></path>
            </svg>
          </button>

          <div className="grid grid-cols-12 lg:gap-[30px]">
            <form className="col-span-12 rounded-[18px]">
              <h1 className="items-center font-semibold text-[28px] leading-normal text-dark mb-6">
                Make Payment
              </h1>

              <div className="flex justify-between mb-6">
                <h2 className="text-dark font-bold text-[28px] leading-normal">
                  {planDetails?.name}
                </h2>
                <p className="text-end text-dark font-bold text-[28px] leading-normal">
                  {CONSTANT_CURRENCY + planDetails?.price}
                </p>
              </div>

              <div className="grid grid-cols-2 gap-5">
                <div className="col-span-2">
                  <label
                    htmlFor="card_holder_name"
                    className="mb-2 inline-block text-dark font-semibold text-xl"
                  >
                    Name on Card
                  </label>
                  <input
                    value={formData.card_holder_name}
                    onChange={handleChange}
                    type="text"
                    name="card_holder_name"
                    id="card_holder_name"
                    className="border-[1.2px] border-dark w-full h-12 sm:h-14 rounded-xl px-4 sm:px-7 focus:border-blue outline-none text-lg sm:text-xl"
                    placeholder="John Smith"
                  />
                </div>
                <div className="col-span-2">
                  <label
                    htmlFor="card_number"
                    className="mb-2 inline-block text-dark font-semibold text-xl"
                  >
                    Card Number
                  </label>
                  <div className="border-[1.2px] border-dark w-full h-12 sm:h-14 rounded-xl px-4 sm:px-7 focus:border-blue outline-none text-lg sm:text-xl">
                    <CardNumberElement
                      options={getCardOptions()}
                      onChange={(e) => setCardComplete(e.complete)}
                      disableLink
                    />
                  </div>
                </div>
                <div className="col-span-2 sm:col-span-1">
                  <label
                    htmlFor="card_expiry_date"
                    className="mb-2 inline-block text-dark font-semibold text-xl"
                  >
                    Expiry Date
                  </label>
                  <div className="border-[1.2px] border-dark w-full h-12 sm:h-14 rounded-xl px-4 sm:px-7 focus:border-blue outline-none text-lg sm:text-xl">
                    <CardExpiryElement
                      options={getCardOptions()}
                      onChange={(e) => setExpiryComplete(e.complete)}
                    />
                  </div>
                </div>
                <div className="col-span-2 sm:col-span-1">
                  <label
                    htmlFor="card_cvv"
                    className="mb-2 inline-block text-dark font-semibold text-xl"
                  >
                    CVC
                  </label>
                  <div className="border-[1.2px] border-dark w-full h-12 sm:h-14 rounded-xl px-4 sm:px-7 focus:border-blue outline-none text-lg sm:text-xl">
                    <CardCvcElement
                      options={getCardOptions()}
                      onChange={(e) => setCvcComplete(e.complete)}
                    />
                  </div>
                </div>
                <div className="col-span-2">
                  <button
                    type="button"
                    onClick={(e) => handleSubmit(e)}
                    className={`h-auto block py-3 px-3 sm:h-14 w-full text-center font-semibold text-lg sm:text-2xl rounded-xl mb-5 sm:mb-[30px] 
    												${
                              isSubmitting
                                ? "bg-gray-400 cursor-not-allowed text-white"
                                : "bg-blue text-white"
                            }`}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Processing..." : "Pay Now"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentModal;
